//import nodes packages
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import qs from 'qs'
import { withRouter } from 'react-router-dom'

//import from shared components
import SolidButton from '../button/solidbutton'
import SimpleCheckbox from '../form/checkbox/simple'

//import shared utilities functions
import DOMAIN_API, { cancelCheckDomain, cancelGetDomainSuggestions } from '../../../utilities/api/domain'

import { usePrevious } from '../../../utilities/function/common'

import {
    getDataFromSuccessResponse,
    getErrorFromFailResponse,
    getMetaFromSuccessResponse,
    isResponseCancelled
} from '../../../utilities/function/apiResponse'

import { getDataFromURL, } from '../../../utilities/function/urlparams'

import { updatePopupNotification } from '../../../app/action'
import { domainnameFieldValidation } from '../form/validation'

//import internals
import SearchDomainResult from './SearchDomainResult'
import { getExtensions } from "../../../utilities/function/extension";

//define internal functions
const domainValidationRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]+\.[a-zA-Z]{2,}?$/i

const getTLDsFromParams = (tlds) => {
    if (tlds) {
        const tldstring = tlds.replace('["', '').replace('"]', '')
        if (tldstring.split(','))
            return tldstring.split(',')
    }
    return null
}

let SearchDomain = (props) => {
    //define variables
    const dispatch = useDispatch()
    const {
        isTransferPage,
        isNewDomainName,
        className,
        location,
        onSubmit,
        init,
        searchItemCallback
    } = props
    const { search } = location
    const urlparams = qs.parse(search.replace('?', ''))
    const { query } = urlparams

    //define variables from hook
    const [isCloseHidden, setIsCloseHidden] = useState(true)
    const [isTransferMode, setIsTransferMode] = useState(false)
    const [requestCheckDomain, setRequestCheckDomain] = useState({})
    const [requestGetDomainSuggestions, setRequestGetDomainSuggestions] = useState({
        currentResult: []
    })
    const [lockContinue, setLockContinue] = useState(false)
    const [domainNameError, setDomainNameError] = useState(false)

    //timeout
    const fieldOnKeyUpTimeout = useRef(null)

    //define elements from hook
    const searchFieldEl = useRef(null)
    const searchFormEl = useRef(null)

    //define previous variables from hook
    const prevParams = usePrevious(urlparams)
    const previsTransferMode = useRef(undefined)
    const prevIsNewDomainName = useRef(undefined)
    const initFlag = useRef(null)
    const initSeachFormValue = useRef(false)

    //define functions
    const checkContentLength = () => {
        if (document && document.querySelector) {
            const searchDomainContainer = document.querySelector('.of-select-hosting-domain__container')
            const searchDomain = document.querySelector('.of-select-hosting-domain')
            if (searchDomainContainer && searchDomainContainer.getBoundingClientRect()) {
                const clientRect = searchDomainContainer.getBoundingClientRect()
                if (clientRect.height > window.innerHeight) {
                    if (searchDomain && searchDomain.classList && !searchDomain.classList.contains('of-step--long')) {
                        searchDomain.classList.add('of-step--long')
                    }
                } else {
                    if (searchDomain && searchDomain.classList && searchDomain.classList.contains('of-step--long')) {
                        searchDomain.classList.remove('of-step--long')
                    }
                }
            }
        }
    }
    const closeButtonOnClick = e => {
        e.preventDefault()
        reset()
    }
    const fieldOnKeyUp = (e) => {
        e.preventDefault()

        const key = e.which
        if (fieldOnKeyUpTimeout.current) {
            window.clearTimeout(fieldOnKeyUpTimeout.current)
        }
        //setDomainNameError(false)
        if (searchFieldEl.current && key !== 13) {
            setLockContinue(searchFieldEl.current.value)
            setDomainNameError(false)
        }

        fieldOnKeyUpTimeout.current = window.setTimeout(() => {
            if (key !== 13 && searchFieldEl && searchFieldEl.current) {
                const val = searchFieldEl.current.value
                setIsCloseHidden(!val)
            }
            if (!isTransferMode && isNewDomainName) {
                if (cancelCheckDomain) {
                    cancelCheckDomain()
                }
                if (cancelGetDomainSuggestions) {
                    cancelGetDomainSuggestions()
                }
                handleCheckNewDomainName()
            }

        }, 500)
    }
    const getPlaceHolder = () => {
        if (isNewDomainName) {
            return ('search or enter a keyword here')
        }
        return ('enter your domain name')
    }

    //define callback functions
    const getDomainInput = useCallback(() => {
        let output = {}
        if (searchFieldEl && searchFieldEl.current && searchFieldEl.current.value) {
            const val = searchFieldEl.current.value
            const stringArray = val.split(".")
            if (stringArray.length > 1) {
                output.domain = val.substr(0, val.indexOf('.'));
                output.tld = "." + val.substr(val.indexOf('.') + 1);
            } else if (stringArray.length === 1) {
                output.domain = stringArray[0]
                output.tld = ".com.au";
            }
        }
        return output
    }, [searchFieldEl])
    const getSuggestionDomainName = useCallback((domain, tlds, page, showmore = false) => {
        if (showmore) {
            setRequestGetDomainSuggestions({
                ...requestGetDomainSuggestions,
                status: 'loading',
            })
        } else {
            setRequestGetDomainSuggestions({
                status: 'loading',
            })
        }
        DOMAIN_API.getDomainSuggestions(domain, tlds, page).then(successresponse => {
            const data = getDataFromSuccessResponse(successresponse)
            const meta = getMetaFromSuccessResponse(successresponse)
            checkContentLength()
            let currentResult = requestGetDomainSuggestions.currentResult
            if (currentResult && showmore) {
                currentResult.push(...data)
            } else {
                currentResult = data
            }
            setRequestGetDomainSuggestions({
                ...requestGetDomainSuggestions,
                status: 'success',
                data: currentResult,
                currentResult,
                meta,
            })
        }, errorresponse => {
            const error = getErrorFromFailResponse(errorresponse)
            if (!isResponseCancelled(error)) {
                updatePopupNotification(dispatch, {
                    status: 'error',
                    error
                })
                setRequestGetDomainSuggestions({
                    ...requestGetDomainSuggestions,
                    status: 'error',
                    error
                })
            }
        })
    }, [requestGetDomainSuggestions, dispatch])
    const checkDomain = useCallback((domain, tlds) => {
        if (cancelCheckDomain) {
            cancelCheckDomain()
        }
        if (cancelGetDomainSuggestions) {
            cancelGetDomainSuggestions()
        }
        setRequestCheckDomain({
            ...requestCheckDomain,
            status: 'loading',
        })
        const action = isTransferMode ? 'transfer' : 'register'
        DOMAIN_API.checkDomain(domain, tlds, action).then(successresponse => {
            const data = getDataFromSuccessResponse(successresponse)
            checkContentLength()
            setRequestCheckDomain({
                status: 'success',
                data
            })
        }, errorresponse => {
            const error = getErrorFromFailResponse(errorresponse)
            if (!isResponseCancelled(error)) {
                setRequestCheckDomain({
                    status: 'error',
                    error
                })
                updatePopupNotification(dispatch, {
                    status: 'error',
                    error
                })
            }
        })
        if (!isTransferMode) {
            getSuggestionDomainName(domain, tlds, 1)
        }

    }, [requestCheckDomain, dispatch, isTransferMode, getSuggestionDomainName])
    const handleCheckNewDomainName = useCallback((tldslist) => {
        let value = searchFieldEl.current.value
        value = value.replace('www.', '')
        value = value.toLowerCase()
        const string = value.split('.')
        const ccTLDS = getExtensions().split(',').filter((extension) => extension.includes('.'))
        const isCCTLDSDomain = ccTLDS.some((ccTLD) => value.includes(ccTLD))
        const hasSubdomain = (domainArray) => {
            return domainArray.length < 3 || (isCCTLDSDomain && domainArray.length < 4)
        }

        if (string.length === 1 && string[0]) {
            if (/\s/i.test(string)) {
                setDomainNameError(true)
            } else {
                setDomainNameError(false)
                if (tldslist && Array.isArray(tldslist) && tldslist.length > 0) {
                    checkDomain(string[0], tldslist)
                } else {
                    checkDomain(string[0], ['.com.au'])
                }
            }
        } else {
            if (value && value.match(domainValidationRegex)) {
                setDomainNameError(false)
                if (string && string.length > 1 && Array.isArray(string) && hasSubdomain(string)) {
                    const domain = string.shift()
                    const tldstring = '.' + string.join('.')
                    if (domain && tldstring) {
                        let tlds = [tldstring]
                        const filteredTLDList = () => {
                            if (tldslist && tldslist.length) {
                                return tldslist.filter(i => i !== tldstring)
                            }
                            return []
                        }
                        tlds = tlds.concat(filteredTLDList())
                        checkDomain(domain, tlds)
                    }
                } else {
                    if (string.length === 1 && string[0]) {
                        if (tldslist && tldslist.length > 0) {
                            checkDomain(string[0], tldslist)
                        } else {
                            checkDomain(string[0], ['.com.au'])
                        }
                    } else {
                        setDomainNameError(true)
                        setRequestCheckDomain({})
                        setRequestGetDomainSuggestions({})
                    }
                }
            } else {
                setDomainNameError(true)
                setRequestCheckDomain({})
                setRequestGetDomainSuggestions({})
            }
        }
    }, [searchFieldEl, checkDomain])
    const reset = useCallback(() => {
        if (cancelCheckDomain) {
            cancelCheckDomain()
        }
        if (cancelGetDomainSuggestions) {
            cancelGetDomainSuggestions()
        }
        searchFieldEl.current.value = ''
        setIsCloseHidden(true)
        setRequestCheckDomain({})
        setRequestGetDomainSuggestions({})
        setDomainNameError(false)
    }, [searchFieldEl])

    const onDomainTabChangeCallback = useCallback(() => {
        if (previsTransferMode.current !== isTransferMode || prevIsNewDomainName.current !== isNewDomainName) {
            if (cancelGetDomainSuggestions) {
                cancelGetDomainSuggestions()
            }
            if (cancelCheckDomain) {
                cancelCheckDomain()
            }
            if (previsTransferMode.current !== undefined && prevIsNewDomainName.current !== undefined) {
                setRequestCheckDomain({})
                setRequestGetDomainSuggestions({})
                if (isNewDomainName && !isTransferPage) {
                    setIsTransferMode(false)
                    if (searchFieldEl && searchFieldEl.current && searchFieldEl.current.value) {
                        handleCheckNewDomainName(getTLDsFromParams(null))
                    }
                } else {
                    if (isTransferPage) {
                        handleCheckNewDomainName(getTLDsFromParams(null))
                        setIsTransferMode(true)
                    }
                }
            }
            if (previsTransferMode.current !== isTransferMode) {
                previsTransferMode.current = isTransferMode
            }
            if (prevIsNewDomainName.current !== isNewDomainName) {
                setDomainNameError(false)
                prevIsNewDomainName.current = isNewDomainName
            }
        }
    }, [isNewDomainName, isTransferPage, searchFieldEl, handleCheckNewDomainName, previsTransferMode, isTransferMode])

    const onURLParamsChangeCallback = useCallback(() => {
        const urlparams = getDataFromURL(search)
        if (prevParams && prevParams !== urlparams) {
            const { domain } = urlparams
            if (urlparams.domain !== domain) {
                setDomainNameError(false)
                setRequestGetDomainSuggestions({})
                setRequestCheckDomain({})
                if (domain === 'register') {
                    const { tlds } = getDataFromURL(location.search)
                    if (searchFieldEl.current.value) {
                        handleCheckNewDomainName(getTLDsFromParams(tlds))
                    }
                }
            }
        }
    }, [search, prevParams, handleCheckNewDomainName, location])

    const onErrorResetCallback = useCallback(() => {
        if (domainNameError) {
            if (cancelCheckDomain) {
                cancelCheckDomain()
            }
            if (cancelGetDomainSuggestions) {
                cancelGetDomainSuggestions()
            }
            if (requestCheckDomain.status) {
                setRequestCheckDomain({})
            }

            //setDomainNameError(false)
        }
    }, [domainNameError, requestCheckDomain])

    const onInitCallback = useCallback(() => {
        if (!initFlag.current && init) {
            init(setIsTransferMode, searchFieldEl)
            initFlag.current = true
        }
    }, [init, searchFieldEl, initFlag, setIsTransferMode])

    const onInitSearchFormValueCallback = useCallback(() => {
        if (initSeachFormValue.current === false) {
            const { tlds } = getDataFromURL(location.search)
            const getTLDsFromParams = () => {
                if (tlds) {
                    const tldstring = tlds.replace('["', '').replace('"]', '')
                    if (tldstring.split(',')) {
                        return tldstring.split(',')
                    }
                }
                return null
            }
            if (query) {
                const string = query.split('.')
                if (string.length === 1 && !getTLDsFromParams()) {
                    searchFieldEl.current.value = query + '.com.au'
                } else {
                    searchFieldEl.current.value = query
                }
                handleCheckNewDomainName(getTLDsFromParams())
                initSeachFormValue.current = true
            }
            setLockContinue(searchFieldEl.current.value)
        }
    }, [query, searchFieldEl, handleCheckNewDomainName, location, initSeachFormValue])

    const onShowCloseButtonCallback = useCallback(() => {
        if (searchFieldEl && searchFieldEl.current) {
            const { value } = searchFieldEl.current
            if (value) {
                setIsCloseHidden(false)
            }
        }
    }, [searchFieldEl])

    useEffect(() => {
        onDomainTabChangeCallback()
        onURLParamsChangeCallback()
        onErrorResetCallback()
        onInitCallback()
        onInitSearchFormValueCallback()
        onShowCloseButtonCallback()
    }, [onDomainTabChangeCallback, onURLParamsChangeCallback, onErrorResetCallback, onInitCallback, onInitSearchFormValueCallback, onShowCloseButtonCallback])

    //define submit button on click function
    const formOnSubmit = e => {
        e.preventDefault()
        setDomainNameError(false)
        let { value } = searchFieldEl.current
        value = value.toLowerCase()
        if (value && onSubmit) {
            if (!isNewDomainName) {
                if (isTransferMode) {
                    if (value && domainnameFieldValidation(value) === undefined) {
                        handleCheckNewDomainName()
                    } else {
                        setDomainNameError(true)
                    }
                } else {
                    if (value && domainnameFieldValidation(value) === undefined) {
                        onSubmit(value, isTransferMode, isNewDomainName)
                    } else {
                        setDomainNameError(true)
                    }
                }
            }
        }
    }

    //render functions
    const renderCloseButton = () => {
        if (!isCloseHidden) {
            return (
                <button onClick={closeButtonOnClick} type='button' className='of-search-domain__close-button'><i
                    className='text-font-1-100 of-search-domain__icon icon-of-blog-close'/></button>
            )
        }
        return ('')
    }
    const renderButton = () => {
        let text = isNewDomainName === false ? 'Continue' : 'Search'
        if (!isNewDomainName) {
            if (isTransferMode) {
                text = 'Search'
            }
            return (
                <SolidButton isDisabled={!lockContinue || domainNameError} className='of-search-domain__button'
                             type='submit'>{text}</SolidButton>
            )
        }
        return (<></>)
    }
    const renderCheckboxField = () => {
        if (!isNewDomainName && !isTransferPage) {
            return (
                <div className='of-search-domain__transfer-option'>
                    <SimpleCheckbox className='of-search-domain__checkbox' label='Transfer my domain name'
                                    value={isTransferMode}
                                    callback={setIsTransferMode}/>
                </div>
            )
        }
        return (<></>)
    }
    const renderError = () => {
        if (domainNameError) {
            return (
                <div className={'of-search-domain__error status-font-2-100'}>Please enter a valid domain name</div>
            )
        }
        return (<></>)
    }
    const renderLoadMoreButton = () => {
        if (requestGetDomainSuggestions && requestGetDomainSuggestions.meta) {
            const { current_page, last_page } = requestGetDomainSuggestions.meta
            const onLoadMoreCallback = () => {
                let next = parseInt(current_page) + 1
                const input = getDomainInput()
                getSuggestionDomainName(input.domain, [input.tld], next, true)
            }
            if (current_page !== last_page && requestGetDomainSuggestions.status === 'success') {
                return (<div className={'of-search-domain-load-more primary-font-1-100'} onClick={onLoadMoreCallback}>
                    Load more domains
                </div>)
            }
        }
        return (<></>)
    }

    return (
        <div className={`of-search-domain${className ? ' ' + className : ''}`}>
            <form ref={searchFormEl} className='of-search-domain__form' onSubmit={formOnSubmit}>
                <div
                    className={`of-search-domain__wrapper text-font-4-100 lines-border-1-100${isNewDomainName ? ' of-search-domain__wrapper--new' : ''}`}>
                    <div className='of-search-domain__www text-font-3-100'>www.</div>
                    <input ref={searchFieldEl} onKeyUp={fieldOnKeyUp} type='text'
                           className='of-search-domain__field text-font-1-100'
                           placeholder={getPlaceHolder()}
                           autoComplete={"off"}
                           autoCorrect={"off"}
                           spellCheck={"false"}
                    />
                    {renderCheckboxField()}
                    {renderCloseButton()}
                </div>
                {renderButton()}
            </form>
            {renderError()}
            <SearchDomainResult isNewDomainName={isNewDomainName} isTransferMode={isTransferMode}
                                searchItemCallback={searchItemCallback} requestCheckDomain={requestCheckDomain}
                                requestGetDomainSuggestions={requestGetDomainSuggestions}/>
            {renderLoadMoreButton()}
        </div>
    )
}

SearchDomain.propTypes = {
    isNewDomainName: PropTypes.bool,
    className: PropTypes.string,
    location: PropTypes.any,
    onSubmit: PropTypes.func,
    init: PropTypes.func,
    searchItemCallback: PropTypes.func,
    isTransferPage: PropTypes.bool
}

SearchDomain = withRouter(SearchDomain)

export default SearchDomain
